<section id="main" class="bg-light">
     <div id="content">
          <div class="container">
               <h1
                    [innerHtml]="'AuditsHeader' | translator: 'audit'"
               >Audit Dashboard
               </h1>            
               <div class="row">
                    <div id="AuditsContainer" class="col-lg-8 mb-3">
                         <div>
                              <div
                                   *ngIf="transactions && transactions.length === 0"
                                   class="alert alert-success"
                              >
                                   <span
                                        [innerHtml]="'NoTransactionsText' | translator: 'audit'"
                                   >
                                        You have no transactions under audit.
                                   </span>
                    
                                   <a
                                        routerLink="/dashboard"
                                        [title]="'NoTransactionsLink' | translator: 'audit'"
                                        [innerHtml]="'NoTransactionsLink' | translator: 'audit'"
                                        id="bcDashboard"
                                        name="bcDashboard"
                                   >Return to Dashboard
                              </a>
                              </div>
                    
                              <div *ngIf="auditPenaltyStatus !== null">
                                   <h2 class="h4" [innerHtml]="'penaltyStatusHeader' | translator: 'audit'">Penalty Status</h2>
                                   <p class="">
                                        <span [innerHtml]="'penaltyText1' | translator: 'audit'">This account received a penalty of</span> {{auditPenaltyStatus.penaltyDescription}}
                                        <span [innerHtml]="'penaltyText2' | translator: 'audit'">on</span> {{auditPenaltyStatus.penaltyStartDate}}
                                        <span [innerHtml]="'penaltyText3' | translator: 'audit'">because one or more audited disclosure and authorization forms did not meet audit requirements. You have</span> {{auditPenaltyStatus.months}}
                                        <span
                                             *ngIf="auditPenaltyStatus.months === 1"
                                             [innerHtml]="'penaltyText4' | translator: 'audit'"
                                        >month</span>
                                        <span
                                             *ngIf="auditPenaltyStatus.months !== 1"
                                             [innerHtml]="'penaltyText5' | translator: 'audit'"
                                        >months</span>
                                        <span [innerHtml]="'penaltyText6' | translator: 'audit'"> remaining before you return to good standing.</span>
                                   </p>
                              </div>
                    
                              <div
                                   *ngIf="transactions && transactions.length > 0"
                                   id="auditTransactionsContainer"
                              >
                                   <hr *ngIf="auditPenaltyStatus !== null">
                                   <h2 class="h4" [innerHtml]="'FormRequirements' | translator: 'audit'">Form Requirements</h2>
                    
                                   <p
                                        [innerHtml]="'formsText1' | translator: 'audit'"
                                   >The forms submitted must clearly indicate the driver's name, driver's signature (electronic or hand-written),
                                        FMCSA-required authorization language, and be dated on or prior to the date of the PSP driver record request.
                                   </p>
                    
                                   <p
                                        [innerHtml]="'formsText2' | translator: 'audit'"
                                   ><b>Use the form below to submit your disclosure and authorization form(s).</b> You will be given the following options:</p>
                                   <ul>
                                        <li
                                             [innerHtml]="'formsText3' | translator: 'audit'"
                                        >Upload the form(s) directly in your web browser</li>
                                        <li
                                             [innerHtml]="'formsText4' | translator: 'audit'"
                                        >Fax the form(s) to 703-841-6370</li>
                                   </ul>
                    
                                   <div class="alert alert-warning">
                                        <span
                                             [innerHtml]="'formsText5' | translator: 'audit'"
                                        >The driver's name, signature, and date must be included on the forms. Please remove or black out any other personally identifiable information, like date of birth, social security number, license number, etc.
                                        </span>
                                   </div>
                                   <hr>
                                   <h2
                                        class="h4"
                                        [innerHtml]="'transHeader' | translator: 'audit'"
                                   >Transactions Under Audit</h2>
                                   <p [innerHtml]="'transText' | translator: 'audit'">The following list of records require disclosure and authorization forms. Upload one or more supporting documents for each record.</p>
                    
                                   <!-- begin repeater -->
                                   <div
                                        class="card shadow-sm rounded-0 border-0"
                                        *ngFor="let tran of transactions; let index = index"
                                        [id]="tran.authCode"
                                   >
                                        <div class="card-body">
                                             <table class="table table-collapsible">
                                                  <thead>
                                                       <tr>
                                                            <th
                                                                 scope="col"
                                                                 [innerHtml]="'transCol1' | translator: 'audit'"
                                                            >Request Date</th>
                                                            <th
                                                                 scope="col"
                                                                 class="text-break"
                                                                 [innerHtml]="'LastName' | translator: 'base'"
                                                            >Last Name</th>
                                                            <th
                                                                 scope="col"
                                                                 class="text-break"
                                                                 [innerHtml]="'FirstName' | translator: 'base'"
                                                            >First Name</th>
                                                            <th
                                                                 scope="col"
                                                                 class="text-break"
                                                                 [innerHtml]="'LicenseNumber' | translator: 'request'"
                                                            >License #</th>
                                                            <th
                                                                 scope="col"
                                                                 [innerHtml]="'State' | translator: 'base'"
                                                            >State</th>
                                                            <th
                                                                 scope="col"
                                                                 [innerHtml]="'transCol6' | translator: 'audit'"
                                                            >Requested by</th>
                                                            <th
                                                                 scope="col"
                                                                 [innerHtml]="'Status' | translator: 'invoice'"
                                                            >Status</th>
                                                       </tr>
                                                  </thead>
                                                  <tbody>
                                                       <tr>
                                                            <td class="text-break">
                                                                 <span
                                                                      class="cell-label"
                                                                      [innerHtml]="'transCol1' | translator: 'audit'"
                                                                 >
                                                                      Request Date
                                                                 </span>
                                                                 <span>{{tran.requestDate | dateTimeFromIso | dateTimeToFormat:'MM/dd/yyyy'}}</span>
                                                            </td>
                                                            <td class="text-break">
                                                                 <span
                                                                      class="cell-label"
                                                                      [innerHtml]="'LastName' | translator: 'base'"
                                                                 >
                                                                      Last Name
                                                                 </span>
                                                                 <span>{{tran.lastName}}</span>
                                                            </td>
                                                            <td class="text-break">
                                                                 <span
                                                                      class="cell-label"
                                                                      [innerHtml]="'FirstName' | translator: 'base'"
                                                                 >
                                                                      First Name
                                                                 </span>
                                                                 <span>{{tran.firstName}}</span>
                                                            </td>
                                                            <td class="text-break">
                                                                 <span
                                                                      class="cell-label"
                                                                      [innerHtml]="'LicenseNumber' | translator: 'base'"
                                                                 >
                                                                      License Number
                                                                 </span>
                                                                 <span>{{tran.dlNum}}</span>
                                                            </td>
                                                            <td class="text-break">
                                                                 <span
                                                                      class="cell-label"
                                                                      [innerHtml]="'State' | translator: 'base'"
                                                                 >
                                                                      State
                                                                 </span>
                                                                 <span>{{tran.dlState}}</span>
                                                            </td>
                                                            <td class="text-break">
                                                                 <span
                                                                      class="cell-label"
                                                                      [innerHtml]="'transCol6' | translator: 'audit'"
                                                                 >
                                                                      Requested By
                                                                 </span>
                                                                 <span>{{tran.requestor}}</span>
                                                            </td>
                                                            <td class="text-break">
                                                                 <span
                                                                      class="cell-label"
                                                                      [innerHtml]="'Status' | translator: 'invoice'"
                                                                 >
                                                                      Status
                                                                 </span>
                                                                 <span>{{translateStates(tran.status)}}</span>
                                                            </td>
                                                       </tr>
                                                  </tbody>
                                             </table>
                                             <div class="mb-3">
                                                  <button
                                                       type="button"
                                                       [disabled]="tran.statusId !== 1"
                                                       class="btn btn-primary me-2"
                                                       *ngIf="tran.documents && tran.documents.length === 0 && tran.docUploadAttempts < 3"
                                                       [title]="'submitDocsBtn' | translator: 'audit'"
                                                       (click)="openSubmitDialog(tran)"
                                                  >
                                                       <span
                                                            [innerHtml]="'submitDocsBtn' | translator: 'audit'"
                                                       >Submit document(s)</span>
                                                  </button>
                                                  <button
                                                       type="button"
                                                       [disabled]="tran.statusId !== 1"
                                                       class="btn btn-primary me-2"
                                                       *ngIf="tran.documents && tran.documents.length > 0 && tran.docUploadAttempts < 3"
                                                       [title]="'resubmitDocsBtn' | translator: 'audit'"
                                                       (click)="openReSubmitDialog(tran)"
                                                  >
                                                       <span
                                                            [innerHtml]="'resubmitDocsBtn' | translator: 'audit'"
                                                       >Resubmit Document(s)</span>
                                                  </button>
                                                  <div
                                                       class="alert alert-info"
                                                       *ngIf="tran.docUploadAttempts >= 3"
                                                       [innerHtml]="'docAttemptsExceeded' | translator: 'audit'"
                                                  >Document upload attempts exceeded for this transaction.</div>
                                             </div>
                                             <p
                                                  class="text-center no-files-message"
                                                  *ngIf="tran.documents && tran.documents.length == 0"
                                                  [innerHtml]="'noDocAttempts' | translator: 'audit'"
                                             >No files uploaded yet.</p>
                                             <div
                                                  class="submitted-documents"
                                                  *ngIf="tran.documents && tran.documents.length > 0"
                                             >
                                                  <table class="table table-collapsible table-vcr">
                                                       <thead>
                                                            <tr>
                                                                 <th
                                                                      scope="col"
                                                                      [innerHtml]="'docHeaderCol1' | translator: 'audit'"
                                                                 >Submitted By</th>
                                                                 <th
                                                                      scope="col"
                                                                      [innerHtml]="'docHeaderCol2' | translator: 'audit'"
                                                                 >Received</th>
                                                                 <th
                                                                      scope="col"
                                                                      [innerHtml]="'docHeaderCol3' | translator: 'audit'"
                                                                 >Action</th>
                                                            </tr>
                                                       </thead>
                                                       <tbody>
                                                            <tr
                                                                 *ngFor="let doc of tran.documents; let index = index"
                                                                 [id]="doc.documentId"
                                                            >
                                                                 <td class="text-break">
                                                                      <span
                                                                           class="cell-label"
                                                                           [innerHtml]="'docHeaderCol1' | translator: 'audit'"
                                                                      >
                                                                           Submitted By
                                                                      </span>
                                                                      {{doc.createdBy}}
                                                                 </td>
                                                                 <td class="text-break">
                                                                      <span
                                                                           class="cell-label"
                                                                           [innerHtml]="'docHeaderCol2' | translator: 'audit'"
                                                                      >
                                                                           Received
                                                                      </span>
                                                                      {{doc.createdDate | dateTimeFromIso | dateTimeToFormat:'MM/dd/yyyy'}}
                                                                 </td>
                                                                 <td class="text-break">
                                                                      <span
                                                                           class="cell-label"
                                                                           [innerHtml]="'docHeaderCol3' | translator: 'audit'"
                                                                      >
                                                                           Action
                                                                      </span>
                                                                      <a
                                                                           *ngIf="doc.mimeTypeId === 2"
                                                                           class='btn btn-primary btn-sm'
                                                                           (click)="showPdfDocument(doc.documentId)"
                                                                           [title]="'View' | translator: 'driver'"
                                                                           tabindex="0"
                                                                      >
                                                                           <span
                                                                                [innerHtml]="'View' | translator: 'driver'"
                                                                           >View</span>
                                                                      </a>
                                                                      <a
                                                                           *ngIf="doc.mimeTypeId !== 2 && doc.mimeTypeId !== 4"
                                                                           class='btn btn-primary btn-sm'
                                                                           (click)="showDocument(doc.documentId)"
                                                                           [title]="'View' | translator: 'driver'"
                                                                           tabindex="0"
                                                                      >
                                                                           <span
                                                                                [innerHtml]="'View' | translator: 'driver'"
                                                                           >View</span>
                                                                      </a>
                                                                 </td>
                                                            </tr>
                                                       </tbody>
                                                  </table>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                    
                              <div
                                   class="overlay"
                                   *ngIf="isLoading"
                              >
                                   <h1
                                        class="heading"
                                        [innerHtml]="'Loading' | translator: 'base'"
                                   >Loading...</h1>
                                   <img :alt="'Loading' | translator: 'base'" />
                              </div>


                              <ng-template #ResubmitModal let-modal>
                                   <div class="modal-header">
                                        <h3
                                             id="resubmitModalTitle" 
                                             class="modal-title"
                                             slot="header"
                                             [innerHtml]="'ResubmitModalTitle' | translator: 'audit'"
                                        >
                                             Re-submit Disclosure and Authorization Form
                                        </h3>
                                   </div>
                                   <div class="modal-body">
                                        <div class="alert alert-warning">
                                             <span
                                                  [innerHtml]="'resubmitWarningText' | translator: 'audit'"
                                             >
                                                  Warning! This action will replace the previous document submission. Click Continue to proceed or Cancel to preserve the current document submission.
                                             </span>
                                        </div>
                                   </div>
                                   <div class="modal-footer">
                                        <button
                                             class="btn btn-primary ms-2"
                                             (click)="continueWithResubmit()"
                                             [title]="'Continue' | translator: 'base'"
                                             id="btnMakeDefaultOk"
                                             name="btnMakeDefaultOk"
                                        >
                                             <span
                                                  [innerHtml]="'Continue' | translator: 'base'"
                                             >Continue</span>
                                        </button>
                                        <button
                                             class="btn btn-outline-primary"
                                             (click)="cancelResubmitModal()"
                                             [title]="'cancel_button' | translator: 'base'"
                                             id="btnMakeDefaultCancel"
                                             name="btnMakeDefaultCancel"
                                        >
                                             <span [innerHtml]="'cancel_button' | translator: 'base'">Cancel</span>
                                        </button>
                                   </div>
                              </ng-template>
                         
                              <ng-template #FaxOrUploadModal let-modal>
                                   <div class="modal-header">
                                        <h3
                                             id="faxOrUploadModalTitle" 
                                             class="modal-title"
                                             slot="header"
                                             [innerHtml]="'FaxOrUploadModalTitle' | translator: 'audit'"
                                        >Submit Disclosure and Authorization Form
                                        </h3>
                                   </div>
                                   <div class="modal-body">
                                        <fieldset>
                                             <legend 
                                                  class="form-label"
                                                  [innerHtml]="'HowSubmitText' | translator: 'audit'"
                                             >How would you like to submit this document?
                                             </legend>
                                             <div class="form-check">
                                                  <label class="form-check-label">
                                                       <input
                                                            id="onlineSubmittalType"
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="submittal_type"
                                                            [(ngModel)]="submittalType"
                                                            value="online"
                                                            (click)="submittalTypeChanged('online')"
                                                       >
                                                       <span [innerHtml]="'UploadText1' | translator: 'audit'">
                                                            Upload file online, will appear directly in your Audit Dashboard
                                                       </span>
                                                       <div
                                                            class="help-block"
                                                            [innerHtml]="'UploadText2' | translator: 'audit'"
                                                       >Acceptable files formats: PDF, JPEG, and PNG</div>
                                                  </label>
                                             </div>
                                             <div class="form-check">
                                                  <label class="form-check-label">
                                                       <input
                                                            id="faxSubmittalType"
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="submittal_type"
                                                            [(ngModel)]="submittalType"
                                                            value="fax"
                                                            (click)="submittalTypeChanged('fax')"
                                                       >
                                                       <span [innerHtml]="'formsText4' | translator: 'audit'">
                                                            Fax the form(s) to 703-841-6370
                                                       </span>
                                                       <div
                                                            class="help-block"
                                                            [innerHtml]="'FaxText2' | translator: 'audit'"
                                                       >
                                                            This option generates a required pre-populated fax cover sheet within your browser window in a printable format.
                                                       </div>
                                                  </label>
                                             </div>
                                        </fieldset>
                                   </div>
                                   <div class="modal-footer">
                                        <button
                                             class="btn btn-primary ms-2"
                                             (click)="selectFaxOrUpload()"
                                             [title]="'Continue' | translator: 'base'"
                                             id="btnMakeDefaultOk"
                                             name="btnMakeDefaultOk"
                                             [disabled]="!allowDocumentSubmissionContinue"
                                        >
                                             <span
                                                  [innerHtml]="'Continue' | translator: 'base'"
                                             >Continue</span>
                                        </button>
                                        <button
                                             class="btn btn-outline-primary"
                                             (click)="cancelFaxOrUploadModal()"
                                             [title]="'cancel_button' | translator: 'base'"
                                             id="btnMakeDefaultCancel"
                                             name="btnMakeDefaultCancel"
                                        >
                                             <span [innerHtml]="'cancel_button' | translator: 'base'">Cancel</span>
                                        </button>
                                   </div>
                              </ng-template>

                              <ng-template #UploadModal let-modal>
                                   <div class="modal-header">
                                        <h3
                                             id="uploadModalTitle" 
                                             class="modal-title"
                                        >
                                             <span [innerHtml]="'uploadModalTitle' | translator: 'audit'">Add document for driver:</span> {{currentTransaction.lastName}}
                                        </h3>
                                   </div>
                                   <div class="modal-body">
                                        <div
                                             class="overlay"
                                             *ngIf="isUploading"
                                        >
                                             <h1 class="heading" [innerHtml]="'Processing' | translator: 'base'">Processing...</h1>
                                        </div>
                                        <p
                                             [innerHtml]="'UploadModalText1' | translator: 'audit'"
                                        >Add one or more files here to complete your document submission.
                                        </p>
                                        <div class="alert alert-warning">
                                             <span
                                                  [innerHtml]="'formsText5' | translator: 'audit'"
                                             >The driver's name, signature, and date must be included on the forms. Please remove or black out any other personally identifiable information, like date of birth, social security number, license number, etc.
                                             </span>
                                        </div>
                                        <h4
                                             [innerHtml]="'uploadedFilesHeader' | translator: 'audit'"
                                             class="h5"
                                        >Uploaded files</h4>
                                        <p
                                             class="text-center no-files-message"
                                             *ngIf="currentTransaction?.documents?.length === 0"
                                             [innerHtml]="'noDocAttempts' | translator: 'audit'"
                                        >No files uploaded yet.</p>
                                        <div
                                             class="modal-submitted-documents"
                                             *ngIf="currentTransaction?.documents?.length > 0"
                                        >
		
                                             <table class="table table-vcr table-light table-collapsible">
                                                  <thead>
                                                       <tr>
                                                            <th scope="col" [innerHtml]="'docHeaderCol1' | translator: 'audit'">Submitted By</th>
                                                            <th scope="col" [innerHtml]="'docHeaderCol2' | translator: 'audit'">Received</th>
                                                            <th scope="col" [innerHtml]="'docHeaderCol3' | translator: 'audit'">Action</th>
                                                       </tr>
                                                  </thead>
                                                  <tbody>
                                                       <tr
                                                            *ngFor="let doc of currentTransaction.documents"
                                                            [attr.key]="doc.documentId"
                                                       >
                                                            <td class="text-break">
                                                                 <span 
                                                                      class="cell-label" 
                                                                      [innerHtml]="'docHeaderCol1' | translator: 'audit'"
                                                       >Submitted By</span>											
                                                                 {{doc.createdBy}}
                                                            </td>
                                                            <td class="text-break">
                                                                 <span 
                                                                      class="cell-label" 
                                                                      [innerHtml]="'docHeaderCol2' | translator: 'audit'"
                                                       >Received</span>												
                                                                 {{doc.createdDate | dateTimeFromIso | dateTimeToLocaleString }}
                                                            </td>
                                                            <td>
                                                                 <span 
                                                                      class="cell-label" 
                                                                      [innerHtml]="'docHeaderCol3' | translator: 'audit'"
                                                       >Action</span>											
                                                                 <a
                                                                      *ngIf="doc.mimeTypeId === 2 || doc.mimeTypeId === 4"
                                                                      class='btn btn-primary btn-sm me-2 mb-2'
                                                                      (click)="showPdfDocument(doc.documentId)"
                                                                      [title]="'View' | translator: 'driver'"
                                                                      tabindex="0"
                                                                 >
                                                                      <span
                                                                           [innerHtml]="'View' | translator: 'driver'"
                                                                      >View</span>
                                                                 </a>
                                                                 <a
                                                                      *ngIf="doc.mimeTypeId !== 2 || doc.mimeTypeId === 4"
                                                                      class='btn btn-primary btn-sm me-2 mb-2'
                                                                      (click)="showDocument(doc.documentId)"
                                                                      [title]="'View' | translator: 'driver'"
                                                                      tabindex="0"
                                                                 >
                                                                      <span
                                                                           [innerHtml]="'View' | translator: 'driver'"
                                                                      >View</span>
                                                                 </a>
                                                                 <button
                                                                      (click)="removeDocument(doc.documentId, doc.authCode, true)"
                                                                      [title]="'btnRemove' | translator: 'audit'"
                                                                      class="btn btn-danger btn-sm mb-2"
                                                                 >
                                                                      <span
                                                                           [innerHtml]="'btnRemove' | translator: 'audit'"
                                                                      >Remove</span>
                                                            </button>
                                                            </td>
                                                       </tr>
                                                  </tbody>
                                             </table>

                                        </div>
                                        <h4
                                             [innerHtml]="'addDocumentsHeader' | translator: 'audit'"
                                             class="h5"
                                        >Add document(s)</h4>
                                        <div class="file-upload-container">
                                             <label for="" class="file-upload-label d-block position-relative overflow-hidden">
                                                  <input type="file" autofocus title="" class="file-upload-input bg-light form-control d-block overlayed" accept=".jpg, .jpeg, .png, .pdf" multiple (change)="uploadDocuments($event)" id="uploadDocumentsId">								
                                                  <span class="file-upload-overlay overlayed">
                                                       <div class="text-center px-3" aria-describedby="uploadDocumentsId">
                                                            <strong>
                                                                 <span [innerHtml]="'docUploadChooseOrDrop1' | translator: 'audit'">Choose File(s)</span>
                                                                 <span class="ms-1" [innerHtml]="'docUploadChooseOrDrop2' | translator: 'audit'">or drag and drop file(s) here.</span>
                                                            </strong>
                                                       </div>
                                                  </span>
                                                  <span class="file-upload-overlay-focus overlayed pe-none"></span>
                                             </label>
                                        </div>
                                        <div class="help-block pt-2 mb-3">
                                             <span
                                                  class="fw-bold"
                                                  [innerHtml]="'AcceptableFormats' | translator: 'audit'"
                                             >Acceptable formats are PDF, JPG, and PNG.</span>
                                        </div>
                                   </div>
                                   <div class="modal-footer">
                                        <button
                                             class="btn btn-primary ms-2"
                                             (click)="completeDocumentUploads()"
                                             [title]="'submitDocsBtn' | translator: 'audit'"
                                             id="btnMakeDefaultOk"
                                             name="btnMakeDefaultOk"
                                             [disabled]="currentTrans.documents.length === 0"
                                        >
                                             <span
                                                  [innerHtml]="'submitDocsBtn' | translator: 'audit'"
                                             >Submit Document(s)</span>
                                        </button>
                                        <button
                                             class="btn btn-outline-primary"
                                             (click)="cancelUploads()"
                                             [title]="'cancel_button' | translator: 'base'"
                                             id="btnMakeDefaultCancel"
                                             name="btnMakeDefaultCancel"
                                        >
                                             <span [innerHtml]="'cancel_button' | translator: 'base'">Cancel</span>
                                        </button>
                                   </div>
                              </ng-template>
                              <ng-template #InvalidFileTypeModal let-modal>
                                   <div class="modal-header">
                                        <h3
                                             id="invalidFileTypeModalTitle" 
                                             class="modal-title"
                                             slot="header"
                                        >
                                             <span [innerHtml]="'invalidFileTypeTitle' | translator: 'audit'">Invalid File Type</span>
                                        </h3>
                                   </div>    
                                   <div class="modal-body">
                                        <span
                                             [innerHtml]="'invalidFileTypeText' | translator: 'audit'"
                                        > You can only upload PDF, JPG, PNG, or JPEG files!
                                        </span>
                                   </div>
                                   <div class="modal-footer">
                                        <button class="btn btn-primary"
                                             [title]="'ok_button' | translator: 'base'"

                                             name="okay" 
                                             (click)="modal.close('Done click')">
                                             <span [title]="'ok_button' | translator: 'audit'" [innerHtml]="'ok_button' | translator: 'base'"
>OK</span>
                                        </button>
                                   </div>
                              </ng-template>
                  
                         </div>
                    </div>
                    <div class="col-lg-4 order-lg-2 sidebar">
                         <app-dashboardsupport></app-dashboardsupport>
                         <div class="card shadow-sm rounded-0 border-0">
                              <div class="card-body">
                                   <h2 class="card-title h5 mt-0" [innerHtml]="'Resources' | translator: 'base'">Resources</h2>
                                   <ul>
                                        <li *ngIf="companyType === 'MC'">
                                             <button
                                             (click)="openDocument('PSPMotorCarrierEnrollment')"
                                             target="_blank"
                                             class="btn btn-link"
                                             [title]="'MAHEnrollAgreement' | translator: 'base'"
                                             [innerHtml]="'MAHEnrollAgreement' | translator: 'base'"
                                             >PSP Monthly Account Holder Enrollment Agreement
                                             </button>
                                        </li>
                                        <li *ngIf="companyType === 'ISP'">
                                             <button
                                             (click)="openDocument('ISPAccountHolderAgreement')"
                                             target="_blank"
                                             class="btn btn-link"
                                             [title]="'ISPEnrollAgreement' | translator: 'base'"
                                             [innerHtml]="'ISPEnrollAgreement' | translator: 'base'"
                                             >PSP Industry Service Provider Enrollment Agreement
                                             </button>
                                        </li>
                                        <li>
                                             <button
                                             class="btn btn-link"
                                             [innerHtml]="'DisclosureAndAuth' | translator: 'base'"
                                             (click)="openDocument('PSPDisclosureandAuthorizationForm')"
                                             target="_blank"
                                             [title]="'DisclosureAndAuth' | translator: 'base'"
                                             >Disclosure and Authorization Form
                                             </button>
                                        </li>
                                   </ul>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     </div>
</section>
